import { CircularProgress } from "lola-framework-ui-test";
import type { JSX, ReactElement, ReactNode } from "react";
import { ElevatedCircleWrapper } from "./ElevatedCircleWrapper";

export interface FlowHeroMarkProps {
  showSpinner?: boolean;
  dropzoneColors?: [string, string];
  backgroundIcon?: string;
  children: ReactNode;
}

/**
 * Fixed spinner slot so spinner vs bare disc keep the same center.
 * Geometry matches Kentucky after its CSS transforms: a bare 128px disc is
 * painted at 90%; loading paints CircularProgress 140 / stroke 6 and a 126px
 * disc at 90%, then scales the whole progress group to 90%.
 */
export const FlowHeroMark = ({
  showSpinner = false,
  dropzoneColors,
  backgroundIcon,
  children,
}: FlowHeroMarkProps) => {
  const disc = (
    <ElevatedCircleWrapper
      size={showSpinner ? 126 : 128}
      circleContainerBg={backgroundIcon}
      iconContainerBg="transparent"
    >
      {children as JSX.Element}
    </ElevatedCircleWrapper>
  );

  return (
    <div
      className={`flow-hero-mark${showSpinner ? " flow-hero-mark--loading" : ""}`}
    >
      {showSpinner && dropzoneColors ? (
        <CircularProgress
          variant="loading"
          size={140}
          strokeWidth={6}
          colors={dropzoneColors}
        >
          {disc as ReactElement}
        </CircularProgress>
      ) : (
        disc
      )}
    </div>
  );
};
